import React, { forwardRef } from 'react';

interface IContentWrapperProps {
	children: React.ReactNode;
	className?: string;
}

export const ContentWrapper = forwardRef<HTMLDivElement, IContentWrapperProps>(({ children, className }, ref) => {
	return (
		<div
			ref={ref}
			className={`w-full md:flex md:flex-col md:items-stretch md:self-center md:w-6/12 md:basis-full ${className}`}>
			{children}
		</div>
	);
});

ContentWrapper.displayName = 'ContentWrapper';
